import React from 'react'
import {BrowserRouter as Router, Routes, Route,  Link, BrowserRouter  } from 'react-router-dom';
const ThanksComp = () => {
  return (
    <>
       <div>
          <div>
            <div className='md:w-[50%] md:py-16 mx-auto'>
              <h1 className='text-[#409BF5]   font-bold text-5xl text-center '>Thank You</h1>
              <p className='text-[#6A7D95] text-lg text-center py-6' >Lorem ipsum dolor sit amet, consectetur adipiscing elit.
               Praesent odio felis, pulvinar non iaculis sed, dignissim 
               eget nulla. Integer id volutpat ipsum. Sed efficitur lobortis
                aliquam.   </p>
                 <div className=' py-6 '>
                 <center>
            <Link to="/" >  <button className='mx-2 text-sm text-blue-500'> Return to Home</button></Link>
              
              </center>
            </div>
            </div>
           
          </div>
        </div>
    </>
  )
}

export default ThanksComp